<template>
    <div class="support-container" style="background-color: white; min-height: 100vh; padding-bottom: 20px;">
      <CContainer>
        <!-- Header -->
        <CRow class="header-row align-items-center">
          <CCol class="col-auto">
            <CButton class="back-button" @click="$router.go(-1)">←</CButton>
          </CCol>
          <CCol class="d-flex justify-content-center">
            <h3 class="page-title">Contact Support</h3>
          </CCol>
        </CRow>
  
        <!-- FAQ Section -->
        <h4 class="section-title mt-5 mb-4">FAQ’s</h4>
        <CRow class="faq-section justify-content-center">
    <CCol xs="6" class="d-flex" v-for="item in faqItems" :key="item.label">
      <div class="faq-item">
        <img :src="item.icon" alt="icon" class="faq-icon" />
        <p class="faq-label">{{ item.label }}</p>
      </div>
    </CCol>
  </CRow>
  
        <!-- Contact Us Section -->
        <h4 class="section-title">Contact Us</h4>
      <div class="contact-card" v-for="contact in contactItems" :key="contact.label">
        <div class="contact-content">
          <img :src="contact.icon" alt="contact-icon" class="contact-icon" />
          <div>
            <h4 class="contact-label">{{ contact.label }}</h4>
            <h4 class="contact-detail">{{ contact.detail }}</h4>
          </div>
        </div>
        <CButton variant="ghost" @click="contact.action">&gt;</CButton>
      </div>
      </CContainer>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        faqItems: [
          { label: "Getting Started", icon: require('@/assets/img/new/group.png') },
          { label: "My Account", icon: require('@/assets/img/new/Icon.png') },
          { label: "Technical Issues", icon: require('@/assets/img/new/technical.png') },
          { label: "Security and Privacy", icon: require('@/assets/img/new/password.png') }
        ],
        contactItems: [
          { label: "Email", detail: "contact@interviewrr.ai", icon: require('@/assets/img/new/email.png'), action: () => window.location.href = 'mailto:contact@interviewrr.ai' },
          { label: "Phone Number", detail: "0193857722", icon: require('@/assets/img/new/phone.png'), action: () => window.location.href = 'tel:0193857722' }
        ]
      };
    }
  };
  </script>
  
  <style scoped>
  .support-container {
    background: #fff;
    padding: 20px;
  }
  .header-row {
    margin-bottom: 20px;
  }
  .back-button {
    font-size: 18px;
    background: none;
    border: none;
  }
  .page-title {
    font-size: 18px;
    font-weight: bold;
  }
  .section-title {
    font-size: 16px;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .faq-section {
  display: flex;
  flex-wrap: wrap;
  gap: 12px; /* Adjusts spacing between items */
}

.faq-item {
  flex: 1; /* Ensures equal width */
  min-height: 120px;
  background: #f8f9fa;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 15px;
  width: 150px;
}

.faq-icon {
  width: 40px;
  height: 40px;
  margin-bottom: 8px;
}

.faq-label {
  font-size: 14px;
  font-weight: 500;
}
  .contact-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f3f4f6;
    padding: 15px;
    border-radius: 16px;
    margin-bottom: 10px;
  }
  .contact-content {
    display: flex;
    align-items: center;
  }
  .contact-icon {
    width: 24px;
    margin-right: 10px;
  }
  .contact-label {
    font-size: 14px;
    font-weight: bold;
  }
  .contact-detail {
    font-size: 12px;
    color: gray;
  }
  </style>
  